'use memo';

import { createFileRoute } from '@tanstack/react-router';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { ExternalIntegrationsPage } from './-components/ExternalIntegrationsPage';

/**
 * 不具合 > 外部システム連携画面 (route 登録)。
 *
 * 本体は `-components/ExternalIntegrationsPage.tsx` に分離 (playbook §3.18:
 * Badge + ActionButton + Icon + HStack + VStack + Text + useTranslation 等の
 * heavy generic を route 直下 inline すると cascade を引き起こす)。
 */
export const Route = createFileRoute('/_stacktrace/issues/external-integrations/')({
  component: ExternalIntegrationsRouteComponent
});
function ExternalIntegrationsRouteComponent() {
  const {
    t
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'issues.externalIntegrations'
  });
  useDocumentTitle(t('pageTitle'));
  return <ExternalIntegrationsPage />;
}